<template>
    <div class="row mt-5">
        <div class="col-3 d-none d-md-block">
            <form>
                <div class="input-group mb-3">
                    <div class="input-group-prepend border-0">
                        <span class="input-group-text bg-gt-orange border-gt-orange" id="basic-addon1">
                            <img src="/img/icons/search.svg">
                        </span>
                    </div>
                    <input type="text" class="form-control" @keyup="filter($event.target.value)" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1">
                </div>
            </form>
            <ul class="no-list-style search-list">
                <li><a class="topic-link active" @click.prevent="topicFilter($event.target,'*')" href="#all">All</a></li>
                <li class="mt-2" v-for="(topic,j) in topics" :key="'topic_link_'+j">
                    <a class="topic-link" @click.prevent="topicFilter($event.target,topic)" :href="'#'+topic" target="_blank" rel="noopener">{{topic}}</a>
                </li>
            </ul>
        </div>

       <ListClass class="col-12 col-md-9" :list="filtered_list">
            <form class="d-md-none ml-5 mr-5">
                <div class="input-group mb-3">
                    <div class="input-group-prepend border-0">
                        <span class="input-group-text bg-gt-orange border-gt-orange" id="basic-addon1">
                            <img src="/img/icons/search.svg">
                        </span>
                    </div>
                    <input type="text" class="form-control" @keyup="filter($event.target.value)" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1">
                </div>
            </form>
       </ListClass>

    </div>
</template>

<script>
    import axios from 'axios';
    import ListClass from './ListClass';

    export default {
        name: 'List',
        props: {
            msg: String
        },
        components: {
            ListClass
        },
        data: function(){
            return {
                topics: [],
                list: [],
                filtered_list: [],
                search: '*',
                topic: '*'
            }
        },
        mounted: function(){
            const self = this;
            var uri = '/class/getClasses/';
            if(window.CLEAR_CACHE){
                uri += '?clear_cache='+window.CLEAR_CACHE
            }
            axios.get(uri)
            .then(function(data){
                data.data.forEach((e)=>{
                    self.list.push(e);
                    self.filtered_list.push(e);
                    self.topics = self.topics.concat(e.Content_Details_JSON__c.topics)
                });
                self.topics = self.topics.reduce((a, x) => a.includes(x) ? a : [...a, x], []).sort()
            });
        },
        methods:{
            filter(search) {
                if(search != '*' && search != ''){
                    this.search = search;
                    this.filtered_list = this.list.filter(word => word.Content_Details_JSON__c.display_title.toLowerCase().includes(search.toLowerCase()) ) 
                } else {
                    this.search = '*'
                    this.filtered_list = this.list
                }

                if (this.topic != '*'){
                    this.topicFilter(null,this.topic);
                }
            },
            topicFilter(target,topic) {

                if(this.search.trim() !== '' && this.search !== '*' && target != null){
                    this.filter(this.search); 
                } else if( this.search === '*' || this.search === '' ) {
                    this.filtered_list = this.list;
                }

                if ( target != null ){
                    var active_links = document.querySelectorAll("li a.topic-link.active");
                    active_links.forEach(function(link) {
                        link.classList.remove('active');
                    });
                    target.classList.add('active');
                }

                if(topic != '*'){
                    this.filtered_list = this.filtered_list.filter((word) => {
                        return word.Content_Details_JSON__c.topics.includes(topic); 
                    }); 
                }

                this.topic = topic
                
                if(topic == '*'){
                    this.filter(this.search); 
                }

            }
        }
    };
</script>
